enum BenefitParticipationStatus {
  PendingDecision = 'Pending decision',
  OptedIn = 'Opted in',
  OptedOut = 'Opted out',
  InvitePending = 'Invite pending',
  Invited = 'Invited',
}

export default BenefitParticipationStatus
